import { useCallback, useMemo } from "react";
import { devHelper } from "../utils";

export function useDevHelper() {
  const isLoadingOnLandingPageDisabled = useMemo(() => {
    return devHelper.isLoadingOnLandingPageDisabled();
  }, []);

  const toggleLoadingOnLandingPage = useCallback(() => {
    devHelper.toggleLoadingOnLandingPage();
  }, []);

  return {
    isLoadingOnLandingPageDisabled,
    toggleLoadingOnLandingPage
  };
}
